(function () {
    const initKlaviyoForms = () => {
        const forms = document.querySelectorAll(".js-klaviyo-form");
        console.log("Forms found:", forms.length);
        const companyId = "QXHH3t";

        forms.forEach(form => {
            if (form.dataset.attached) return;

            form.addEventListener("submit", function (e) {
                e.preventDefault();

                // 1. Find the elements for this specific form
                const emailInput = form.querySelector(".js-klaviyo-email");
                const submitBtn = form.querySelector('button[type="submit"]');
                const email = emailInput ? emailInput.value : "";
                const listId = form.dataset.listId;
                const originalBtnText = submitBtn.innerText;

                const honeypot = form.querySelector(".js-honeypot");

                if (honeypot && honeypot.value.trim() !== "") {
                    console.warn("Bot detected. Submission blocked.");
                    return;

                }

                // 2. Disable button and show "Loading" state
                submitBtn.disabled = true;
                submitBtn.innerText = "Sending...";
                submitBtn.style.opacity = "0.7";
                submitBtn.style.cursor = "not-allowed";

                fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
                    method: 'POST', headers: {
                        'revision': '2024-02-15', 'content-type': 'application/json'
                    }, body: JSON.stringify({
                        data: {
                            type: 'subscription', attributes: {
                                profile: {
                                    data: {
                                        type: 'profile', attributes: {email: email}
                                    }
                                }
                            }, relationships: {
                                list: {
                                    data: {
                                        type: 'list', id: listId
                                    }
                                }
                            }
                        }
                    })
                })
                    .then(response => {
                        // 3. Show Success Modal
                        const successModal = document.getElementById("klaviyo-success");
                        if (successModal) {
                            successModal.classList.remove("hidden");
                            successModal.classList.add("flex");
                        }
                        form.reset();
                    })
                    .catch(error => {
                        console.error("Klaviyo Error:", error);
                        alert("Something went wrong. Please try again.");
                    })
                    .finally(() => {
                        // 4. Re-enable the button (in case they close the modal and want to sign up again/use another email)
                        submitBtn.disabled = false;
                        submitBtn.innerText = originalBtnText;
                        submitBtn.style.opacity = "1";
                        submitBtn.style.cursor = "pointer";
                    });
            });

            form.dataset.attached = "true";
        });
    };

    if (document.readyState === "complete") {
        initKlaviyoForms();
    } else {
        window.addEventListener("load", initKlaviyoForms);
    }
    document.addEventListener("shopify:section:load", initKlaviyoForms);
})();

document.addEventListener('alpine:init', () => {
    Alpine.data('backgroundStyling', (p) => ({
        imageUrl: p.imageUrl,
        teaser_mobile_zoom: p.teaser_mobile_zoom,
        teaser_desktop_zoom: p.teaser_desktop_zoom,
        image_alignment_mobile: p.image_alignment_mobile,
        image_alignment_desktop: p.image_alignment_desktop,
        transformX: p.transformX,
        isMobile: window.innerWidth <= 1024,
        init() {
            window.addEventListener('resize', () => {
                this.isMobile = window.innerWidth <= 1024;
            });
        },
        getBackgroundStyle() {
            const zoom = this.isMobile ? this.teaser_mobile_zoom : this.teaser_desktop_zoom;
            const pos = this.isMobile ? this.image_alignment_mobile : this.image_alignment_desktop;
            const tx = this.isMobile ? 'translateX(0%)' : `translateX(${this.transformX})`;
            return `background-image:url(${this.imageUrl});background-size:${zoom};background-position:${pos};background-repeat:no-repeat;transform:${tx};`;
        }
    }));
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.image-teaser-swiper').forEach(function (el) {
        const speed = parseInt(el.dataset.speed || '2000');
        const delay = parseInt(el.dataset.delay || '5000');
        const total = speed + delay;

        function setOverlayState(swiper) {
            swiper.el.querySelectorAll('.slide-overlay').forEach(o => o.classList.remove('is-in'));
            const active = swiper.el.querySelector('.swiper-slide-active .slide-overlay');
            if (active) requestAnimationFrame(() => active.classList.add('is-in'));
        }

        function resetBars(swiper) {
            swiper.el.querySelectorAll('.swiper-progress-bar').forEach(b => {
                b.style.transition = 'none';
                b.style.width = '0%';
            });
        }

        function startActiveBar(swiper, total) {
            const active = swiper.pagination.bullets[swiper.realIndex];
            const bar = active?.querySelector('.swiper-progress-bar');
            if (bar) {
                requestAnimationFrame(() => {
                    bar.style.transition = `width ${total}ms linear`;
                    bar.style.width = '100%';
                });
            }
        }

        // Mobile "below" hooks (under the slideshow)
        const teaserSection = el.closest('.teaser-section');
        const mobileWrap = teaserSection?.querySelector('.slideshow-mobile-below');
        const mTitle = mobileWrap?.querySelector('.itm-title');
        const mEdition = mobileWrap?.querySelector('.itm-edition');
        const mCta = mobileWrap?.querySelector('.itm-cta');

        function getActiveSlide(swiper) {
            return swiper.el.querySelector('.swiper-slide.swiper-slide-active') || swiper.el.querySelector(`.swiper-slide[data-swiper-slide-index="${swiper.realIndex}"]`);
        }

        function setMobileBelow(swiper) {
            if (!mobileWrap) return;
            const s = getActiveSlide(swiper);
            if (!s) return;

            const txt = s.getAttribute('data-title') || '';
            const ed = s.getAttribute('data-edition') || '';
            const href = s.getAttribute('data-cta-url') || (mCta?.getAttribute('href') || '#');
            const cta = s.getAttribute('data-cta-text') || '';

            if (mTitle) mTitle.textContent = txt;
            if (mEdition) mEdition.textContent = ed && ed !== '-' ? ed : '';
            if (mCta) {
                mCta.setAttribute('href', href);
                // try to update the visible label inside your button markup
                const label = mCta.querySelector('.button__text, .btn__text, .btn-label, span, strong');
                if (label && cta) label.textContent = cta;
            }

            mobileWrap.querySelectorAll('.fade-piece').forEach(n => {
                n.classList.remove('in');
                void n.offsetWidth;
                n.classList.add('in');
            });
        }

        const swiper = new Swiper(el, {
            effect: 'fade',
            loop: true,
            speed: speed,
            autoplay: {delay: delay, disableOnInteraction: false},
            fadeEffect: {crossFade: true},
            observer: true,
            observeParents: true,
            pagination: {
                el: el.querySelector('.image-teaser-pagination'),
                clickable: true,
                renderBullet: (i, className) => `<div class="${className} relative w-10 h-1 overflow-hidden">
             <div class="absolute top-0 left-0 h-full swiper-progress-bar" style="width:0%"></div>
           </div>`
            },
            on: {
                init(sw) {
                    setOverlayState(sw);
                    startActiveBar(sw, total);
                    setTimeout(() => setMobileBelow(sw), 0);
                }, slideChangeTransitionStart(sw) {
                    resetBars(sw);
                    startActiveBar(sw, total);
                    setMobileBelow(sw);
                }, slideChangeTransitionEnd(sw) {
                    setOverlayState(sw);
                }
            }
        });
    });
});

/* Product teaser swiper (mobile) */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.teaser-swiper').forEach(function (swiperContainer) {
        const slidesPerView = parseInt(swiperContainer.dataset.slidesPerView) || 2;
        new Swiper(swiperContainer, {
            loop: false,
            speed: 1000,
            slidesPerView: slidesPerView,
            slidesPerGroup: slidesPerView,
            resistanceRatio: 0.1,
            pagination: {el: swiperContainer.querySelector('.teaser-swiper-pagination'), clickable: true}
        });
    });
});

function initKlaviyoInputs() {
    document.querySelectorAll('.js-klaviyo-email').forEach(function (input) {
        if (input.dataset.bound) return;

        const original = input.getAttribute('placeholder');

        input.addEventListener('focus', function () {
            this.setAttribute('placeholder', '');
        });

        input.addEventListener('blur', function () {
            if (!this.value) {
                this.setAttribute('placeholder', original);
            }
        });

        input.dataset.bound = "true";
    });
}

document.addEventListener('DOMContentLoaded', initKlaviyoInputs);
document.addEventListener('shopify:section:load', initKlaviyoInputs);

// Re-run in case Klaviyo injects/replaces DOM after load
setTimeout(initKlaviyoInputs, 1000);

function initImageShowcaseSlider() {
    document.querySelectorAll('.image-showcase-swiper').forEach(function (swiperContainer) {
        if (swiperContainer.swiper) return;

        new Swiper(swiperContainer, {
            loop: true,
            speed: 1000,
            centeredSlides: true,
            slidesPerView: 1.3,
            spaceBetween: 0,
            watchSlidesProgress: true,
            autoplay: {
                delay: 5000, disableOnInteraction: false
            },
            pagination: {
                el: swiperContainer.querySelector('.image-showcase-pagination'), clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.5, spaceBetween: 4
                }
            },
            on: {

                progress(swiper) {

                    swiper.slides.forEach(function (slide) {

                        const card = slide.querySelector('.image-showcase-card');

                        if (!card) return;

                        const progress = Math.min(Math.abs(slide.progress), 1);

                        const scale = 1 - progress * 0.06;

                        card.style.transform = `scale(${scale})`;

                    });

                },

                setTransition(swiper, duration) {

                    swiper.slides.forEach(function (slide) {

                        const card = slide.querySelector('.image-showcase-card');

                        if (!card) return;

                        card.style.transitionDuration = `${duration}ms`;

                    });

                }

            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initImageShowcaseSlider);
document.addEventListener('shopify:section:load', initImageShowcaseSlider);

// Safari may defer native autoplay while the teaser's fade container is hidden.
// Retry only opted-in autoplay videos when their visible presentation is ready.
function initTeaserAutoplay() {
    document.querySelectorAll('.bg-image-container video[autoplay]').forEach(video => {
        if (video.dataset.teaserAutoplayBound) return;
        video.dataset.teaserAutoplayBound = 'true';
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        let pending = false;
        const start = () => {
            if (document.hidden || pending || video.ended || !video.paused) return;
            const rect = video.getBoundingClientRect();
            if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= innerHeight) return;
            for (let node = video; node; node = node.parentElement) {
                const style = getComputedStyle(node);
                if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
            }
            pending = true;
            video.play().then(() => {
                delete video.dataset.autoplayError;
            }).catch(error => {
                video.dataset.autoplayError = error.name;
            }).finally(() => { pending = false; });
        };
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) start();
        });
        observer.observe(video);
        video.addEventListener('loadeddata', start);
        video.addEventListener('canplay', start);
        const container = video.closest('.bg-image-container');
        container.addEventListener('animationend', start);
        container.addEventListener('transitionend', start);
        window.addEventListener('pageshow', start);
        document.addEventListener('visibilitychange', start);
        requestAnimationFrame(start);
    });
}

document.addEventListener('DOMContentLoaded', initTeaserAutoplay);
document.addEventListener('shopify:section:load', initTeaserAutoplay);

function initStoryVideos() {

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            const video = entry.target;

            if (entry.isIntersecting) {
                video.play().catch(() => {
                });

            } else {
                video.pause();

            }

        });

    }, {

        threshold: 0,
        rootMargin: '200px 0px'

    });

    document.querySelectorAll('.js-story-video').forEach(video => {

        if (video.dataset.bound) return;
        observer.observe(video);

        video.dataset.bound = "true";

    });

}

document.addEventListener('DOMContentLoaded', initStoryVideos);
document.addEventListener('shopify:section:load', initStoryVideos);

document.addEventListener("click", function (e) {

    const button = e.target.closest("[data-scroll]");

    if (!button) return;

    const target = document.querySelector(button.dataset.scroll);

    if (!target) return;

    const offset = 100; // pixels

    window.scrollTo({

        top: target.offsetTop - offset,

        behavior: "smooth"

    });

});
